'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxSaga = require('redux-saga');

var _messageBus = require('@wh/message-bus');

var messageBus = _interopRequireWildcard(_messageBus);

var _ThemeProvider = require('@sitebase/theme-context/es/ThemeProvider');

var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);

var _AssetsProvider = require('@sitebase/assets-context/es/AssetsProvider');

var _AssetsProvider2 = _interopRequireDefault(_AssetsProvider);

var _MediaProvider = require('@sitebase/media-context/es/MediaProvider');

var _MediaProvider2 = _interopRequireDefault(_MediaProvider);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _quickDepositComponent = require('./quick-deposit-component');

var _LayoutContext = require('./components/LayoutContext');

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuickDeposit = function (_React$Component) {
  (0, _inherits3.default)(QuickDeposit, _React$Component);

  function QuickDeposit(props) {
    (0, _classCallCheck3.default)(this, QuickDeposit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuickDeposit.__proto__ || (0, _getPrototypeOf2.default)(QuickDeposit)).call(this, props));

    _this.store = {};
    return _this;
  }

  (0, _createClass3.default)(QuickDeposit, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      this.store = (0, _store2.default)();

      if (process.env.NODE_ENV === 'development') {
        if (module.hot) {
          // Enable Webpack hot module replacement for reducers
          // https://github.com/reactjs/react-redux/releases/tag/v2.0.0
          module.hot.accept('./store', function () {
            _this2.store.replaceReducer((0, _store2.default)());
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.dispatch(_reduxSaga.END);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _ThemeProvider2.default,
        null,
        _react2.default.createElement(
          _AssetsProvider2.default,
          null,
          _react2.default.createElement(
            _MediaProvider2.default,
            null,
            _react2.default.createElement(
              _reactRedux.Provider,
              { store: this.store },
              _react2.default.createElement(
                _LayoutContext.LayoutProvider,
                { layout: this.props.layout || _constants.QD_DEFAULT_LAYOUT },
                _react2.default.createElement(_quickDepositComponent.QuickDepositComponent, { config: this.props, messageBus: messageBus })
              )
            )
          )
        )
      );
    }
  }]);
  return QuickDeposit;
}(_react2.default.Component);

exports.default = QuickDeposit;